import { AuthServerProvider } from "../../shared/auth/auth.service";
import { Injector } from "@angular/core";
import { Auth401Service } from "../../shared/auth/auth401.service";
import { of } from "rxjs/observable/of";

export class AuthJsInterceptor {
    public static Factory(
        authServerProvider: AuthServerProvider,
        $q: ng.IQService,
        $injector: Injector,
        auth401Service: Auth401Service) {
        return new AuthJsInterceptor(authServerProvider, $q, $injector, auth401Service);
    }

    constructor(
        private authServerProvider: AuthServerProvider,
        private $q: ng.IQService,
        private $injector: Injector,
        private auth401Service: Auth401Service) {
    }

    private get http() {
        return this.$injector.get("$http");
    }

    public request = (config) => {
        config.headers = config.headers || {};

        const jwtToken = this.authServerProvider.getToken();
        if (!!jwtToken) {
            this.addJwtToken(config, jwtToken);
        }

        return config;
    }

    public responseError = (response) => {
        if (response && response.status === 401) {

            const deferred = this.$q.defer();
            const authorizationHeader: string = response.config.headers.Authorization;

            this.auth401Service
                .handle401Error(
                    newJwtToken => {
                        this.addJwtToken(response.config, newJwtToken);
                        return of(this.http(response.config));
                    },
                    response,
                    !!authorizationHeader,
                    () => this.extractJwtToken(authorizationHeader))
                .subscribe(
                    retryResult => deferred.resolve(retryResult),
                    error => deferred.reject(error));

            return deferred.promise;
        }

        return response;
    }

    private addJwtToken(config: any, jwtToken: string): void {
        config.headers.Authorization = 'Bearer ' + jwtToken;
    }

    private extractJwtToken(authorizationHeader: string): string {
        if (!authorizationHeader || !authorizationHeader.startsWith("Bearer ")) {
            return null;
        }

        return authorizationHeader.substring(7);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/blocks/interceptor/authjs.interceptor.ts